import { render } from "./SoAExtraction.vue?vue&type=template&id=d65263e8&scoped=true"
import script from "./SoAExtraction.js?vue&type=script&lang=js"
export * from "./SoAExtraction.js?vue&type=script&lang=js"

import "./SoAExtraction.vue?vue&type=style&index=0&id=d65263e8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d65263e8"]])

export default __exports__